import styled from 'styled-components';
import { Button } from '@pearsontechnology/aero-components';

export const Container = styled.div`
  padding: 30px 20px 10px 20px;
`;

export const Header = styled.div`
  font-size: 18px;
  line-height: 20px;
`;

export const WarningIconContainer = styled.span`
  position: absolute;
`;

export const HeaderTitle = styled.div`
  padding: 0 30px;
`;

export const CloseButton = styled(Button)`
  position: absolute;
  right: 0px;
  top: 0px;
`;

export const MessageLine = styled.div`
  font-size: 14px;
  line-height: 20px;
  margin: 10px 0;
`;